module.exports = __webpack_public_path__ + "media/flags/co-7dd18389.svg";